const inlineElementTypes = [
  'checkbox'
]

export function withInlines (editor) {
  const { isInline } = editor

  editor.isInline = element =>
    inlineElementTypes.includes(element.type) ||
    isInline(element)

  return editor
}
